import useLocalStorage from "./useLocalStorage";

export const useSwipeableEnabled = () => {
    const [swipeable, setSwipeable] = useLocalStorage("swipeable", true);
    const toggleSwipeable = () => {
        setSwipeable((prev) => !prev);
    };
    return {
        isSwipeableOn: swipeable,
        toggleSwipeable,
    };
};
